export default [
  {
    path: '/demo-control',
    name: 'demoControl',
    component: () => import('@/views/demo/DemoControl.vue'),
    meta: {},
  },
  {
    path: '/demo-combobox',
    name: 'demoCombobox',
    component: () => import('@/views/demo/DemoCombobox.vue'),
    meta: {},
  },
  {
    path: '/demo-grid-view-normal',
    name: 'demoGridViewNormal',
    component: () => import('@/views/demo/DemoGridViewNormal.vue'),
    meta: {},
  },
  {
    path: '/demo-grid-edit',
    name: 'demoGridEdit',
    component: () => import('@/views/demo/DemoGridEdit.vue'),
    meta: {},
  },
  {
    path: '/demo-form',
    name: 'demoForm',
    component: () => import('@/views/demo/DemoForm.vue'),
    meta: {},
  },
  {
    path: '/demo-message',
    name: 'demoMessage',
    component: () => import('@/views/demo/DemoMessage.vue'),
    meta: {},
  },
  {
    path: '/demo-toast',
    name: 'demoToast',
    component: () => import('@/views/demo/DemoToast.vue'),
    meta: {},
  },
];
